import React, { useContext } from 'react'
import Footer from '../Footer'
import Header from '../Header'
import Userpagearea from '../Userpagearea';

function Userpage() {


    return (
        <div>
        <Header/>
        <Userpagearea/>
        <Footer/>
            
        </div>
    )
}

export default Userpage
